import { ContextNavigationStyle } from './side-navigation.models';

export const ROOT_PATH = 'dashboard';

export enum CONTEXT_NAVIGATION_ITEMS {
  MASTER_DATA = 'master-data',
  DOCUMENTS = 'documents',
  TASKS = 'tasks',
  LOGBOOK = 'logbook',
  NOTES = 'notes',
  APPOINTMENTS = 'appointments',
  PERMISSIONS = 'permissions',
}

export const CONTEXT_NAVIGATION_STYLE_CONFIG: ContextNavigationStyle = {
  showContext: true,
  title: 'app.sidemenu.contextTitlePatient',
  icon: 'person',
  actionIcon: 'data_loss_prevention',
  actionIconTitle: 'app.sidemenu.contextActionIconTitlePatient',
  context: 'app.sidemenu.nopatient',
  class: 'patient-menu',
};
